import { MouseEventHandler } from 'react';

import { ArrowButton } from 'components/ArrowButton/ArrowButton';
import { CmsTileModalCloseButton } from 'modules/cms/modals/TileModal/CloseButton/CmsTileModalCloseButton';

import {
  CmsTileModalMobileHeaderArrowsContainer,
  CmsTileModalMobileHeaderContainer,
} from './CmsTileModalMobileHeader.styled';

type Props = {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: MouseEventHandler<HTMLButtonElement>;
  onNext: MouseEventHandler<HTMLButtonElement>;
  onClose: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalMobileHeader({
  hasPrevious,
  onPrevious,
  hasNext,
  onNext,
  onClose,
}: Props) {
  return (
    <CmsTileModalMobileHeaderContainer>
      <CmsTileModalMobileHeaderArrowsContainer>
        <ArrowButton
          direction="left"
          onClick={onPrevious}
          disabled={!hasPrevious}
        />

        <ArrowButton direction="right" onClick={onNext} disabled={!hasNext} />
      </CmsTileModalMobileHeaderArrowsContainer>

      <CmsTileModalCloseButton onClick={onClose} />
    </CmsTileModalMobileHeaderContainer>
  );
}
